import script from "./KendouAnalyzerJobPage.vue?vue&type=script&setup=true&lang=js"
export * from "./KendouAnalyzerJobPage.vue?vue&type=script&setup=true&lang=js"

import "./KendouAnalyzerJobPage.vue?vue&type=style&index=0&id=f2b41be2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f2b41be2"]])

export default __exports__